var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calculator"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48,20H16a1,1,0,0,1-1-1V9a1,1,0,0,1,1-1H48a1,1,0,0,1,1,1V19A1,1,0,0,1,48,20ZM17,18H47V10H17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,61H12a1,1,0,0,1-1-1V4a1,1,0,0,1,1-1H52a1,1,0,0,1,1,1V60A1,1,0,0,1,52,61ZM13,59H51V5H13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5,30H17a1,1,0,0,1-1-1V23a1,1,0,0,1,1-1h7.5a1,1,0,0,1,1,1v6A1,1,0,0,1,24.5,30ZM18,28h5.5V24H18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.75,30h-7.5a1,1,0,0,1-1-1V23a1,1,0,0,1,1-1h7.5a1,1,0,0,1,1,1v6A1,1,0,0,1,35.75,30Zm-6.5-2h5.5V24h-5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,30H39.5a1,1,0,0,1-1-1V23a1,1,0,0,1,1-1H47a1,1,0,0,1,1,1v6A1,1,0,0,1,47,30Zm-6.5-2H46V24H40.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5,42H17a1,1,0,0,1-1-1V35a1,1,0,0,1,1-1h7.5a1,1,0,0,1,1,1v6A1,1,0,0,1,24.5,42ZM18,40h5.5V36H18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.75,42h-7.5a1,1,0,0,1-1-1V35a1,1,0,0,1,1-1h7.5a1,1,0,0,1,1,1v6A1,1,0,0,1,35.75,42Zm-6.5-2h5.5V36h-5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,42H39.5a1,1,0,0,1-1-1V35a1,1,0,0,1,1-1H47a1,1,0,0,1,1,1v6A1,1,0,0,1,47,42Zm-6.5-2H46V36H40.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5,54H17a1,1,0,0,1-1-1V47a1,1,0,0,1,1-1h7.5a1,1,0,0,1,1,1v6A1,1,0,0,1,24.5,54ZM18,52h5.5V48H18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.75,54h-7.5a1,1,0,0,1-1-1V47a1,1,0,0,1,1-1h7.5a1,1,0,0,1,1,1v6A1,1,0,0,1,35.75,54Zm-6.5-2h5.5V48h-5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,54H39.5a1,1,0,0,1-1-1V47a1,1,0,0,1,1-1H47a1,1,0,0,1,1,1v6A1,1,0,0,1,47,54Zm-6.5-2H46V48H40.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.b034dbcac0b672fd9de88bbf826f05d7.svg";
export { ForwardRef as ReactComponent };